/**
 * Fetch wrapper that injects the Firebase ID token into every request
 * to the simulator management API. X-CONNECTOR-ID is only sent when
 * selectedConnectorId is set (super-admin viewing another company's simulator).
 */
import useAuth from "src/context/AuthContext/useAuth";

type Method = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

const useSimApi = () => {
  const { idToken, selectedConnectorId } = useAuth();

  const request = async (
    path: string,
    method: Method = "GET",
    body?: unknown
  ): Promise<Response> => {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
    };
    if (idToken) {
      headers["Authorization"] = `Bearer ${idToken}`;
    }
    if (selectedConnectorId != null) {
      headers["X-CONNECTOR-ID"] = String(selectedConnectorId);
    }
    return fetch(path, {
      method,
      headers,
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  };

  return { request };
};

export default useSimApi;
